import { useTheme } from "@emotion/react";
import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Modal,
  Slide,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { tryRegOrder } from "../../stateManagement/reducers/ordersReducer";
import AnimateButton from "../@extended/AnimateButton";
import MDBox from "../MDBox";
import MDTypography from "../MDTypography";
import CartItem from "./CartItem";

const CartModal = ({ isModalOpen, openModal, showOrderPlacementModal }) => {
  const toggleModal = () => {
    openModal(!isModalOpen);
  };
  const { authToken, user } = useSelector((state) => state.auth);
  const { cart } = useSelector((state) => state.cart);

  const dispatch = useDispatch();

  const theme = useTheme();
  const idGreaterThanMd = useMediaQuery(theme.breakpoints.up("md"));

  const placeOrder = () => {
    dispatch(
      tryRegOrder({
        authToken,
        data: {
          userIsCustomer: true,
          customerId: user.customerId,
          rentalItems: cart.items.map((cartItem) => ({
            _id: cartItem.rentalItem._id,
            count: cartItem.count,
          })),
        },
      }),
    );
  };

  const getCartTotalPrice = () => {
    let totalPrice = 0;

    for (const item of cart.items) {
      totalPrice += item.count * item.rentalItem.pricePerDay;
    }

    return totalPrice;
  };

  return (
    <>
      <MDBox component="section" py={6} px={2}>
        <Container>
          <Modal
            open={isModalOpen}
            onClose={toggleModal}
            sx={{
              display: "grid",
              placeItems: "center",
              maxHeight: "100vh !important",
              overflowY: "auto !important",
              p: "1rem !important",
            }}
          >
            <Slide direction="down" in={isModalOpen} timeout={500}>
              <MDBox
                sx={{
                  maxWidth: "500px",
                  width: "100%",
                }}
                position="relative"
                display="flex"
                flexDirection="column"
                borderRadius="xl"
                bgColor="white"
                shadow="xl"
              >
                <MDBox
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  p={2}
                >
                  <MDTypography variant="h5">Cart</MDTypography>
                  <AnimateButton>
                    <Close
                      fontSize="medium"
                      color="error"
                      sx={{ cursor: "pointer" }}
                      onClick={toggleModal}
                    />
                  </AnimateButton>
                </MDBox>
                <Divider textAlign="center" sx={{ my: 0 }} />
                {cart.items.length > 0 && (
                  <>
                    <div className="modal-body">
                      <Stack
                        alignItems="center"
                        spacing={4}
                        sx={{
                          overflowY: "auto",
                          maxHeight: "20rem !important",
                          px: ".5rem",
                          p: "1rem",
                        }}
                      >
                        {[...cart.items].reverse().map((cartItem) => (
                          <CartItem cartItem={cartItem} />
                        ))}
                      </Stack>
                    </div>
                    <Divider sx={{ my: 0 }} />
                    <Grid
                      container
                      direction="row"
                      spacing="space-between"
                      sx={{ mt: "1rem", px: "2rem" }}
                    >
                      <Grid item xs={6}>
                        <Typography
                          variant="h6"
                          display="block"
                          sx={{
                            fontSize: "1rem !important",
                            lineHeight: "1rem !important",
                            color: "black !important",
                          }}
                        >
                          Total:
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          variant="h6"
                          display="block"
                          sx={{
                            fontSize: "1rem !important",
                            lineHeight: "1rem !important",
                            color: "black !important",
                            textAlign: "right",
                          }}
                        >
                          {`$${getCartTotalPrice()}`}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      spacing="space-between"
                      sx={{ my: "2rem", px: "2rem" }}
                    >
                      <Grid item xs={6}>
                        <AnimateButton>
                          <Button
                            variant="contained"
                            size={idGreaterThanMd ? "large" : "small"}
                            color="info"
                            sx={{
                              background:
                                "linear-gradient(to top, #8b0000, #ff5e57) !important",
                            }}
                            onClick={() => {
                              openModal(false);
                            }}
                          >
                            <b>Exit Cart</b>
                          </Button>
                        </AnimateButton>
                      </Grid>
                      <Grid item xs={6} sx={{ display: "flex" }}>
                        <Box component="span" sx={{ ml: "auto !important" }}>
                          <AnimateButton>
                            <Button
                              variant="contained"
                              size={idGreaterThanMd ? "large" : "small"}
                              color="info"
                              sx={{
                                background:
                                  "linear-gradient(to top,#2b6e3f, #4caf50) !important",
                                ml: "auto",
                              }}
                              onClick={() => {
                                openModal(false);
                                showOrderPlacementModal();
                              }}
                            >
                              <b>Place Order</b>
                            </Button>
                          </AnimateButton>
                        </Box>
                      </Grid>
                    </Grid>
                  </>
                )}
                {!cart.items.length && (
                  <div className="modal-body">
                    <Stack
                      alignItems="center"
                      spacing={4}
                      sx={{
                        overflowY: "auto",
                        maxHeight: "20rem !important",
                        px: ".5rem",
                        m: "1rem",
                      }}
                    >
                      <h3 className="mb-0">Your Cart is empty.</h3>
                      <AnimateButton>
                        <Button
                          variant="contained"
                          size="large"
                          color="info"
                          sx={{
                            background:
                              "linear-gradient(to top, #8b0000, #ff5e57) !important",
                          }}
                          onClick={() => {
                            openModal(false);
                          }}
                        >
                          <b>Exit Cart</b>
                        </Button>
                      </AnimateButton>
                    </Stack>
                  </div>
                )}
              </MDBox>
            </Slide>
          </Modal>
        </Container>
      </MDBox>
    </>
  );
};

export default CartModal;
